// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__fsilp","active":"SwitchDate_active__VHUV1"};